import React, { useEffect, useState } from 'react';
import { Navbar, Nav, Button } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';

const PillNavbar = () => {
  const [paths, setPaths] = useState({});
  const [isOpen, setIsOpen] = useState(false); // State for navbar toggler

  useEffect(() => {
    const navbarContainer = document.getElementById('pill-navbar');

    if (navbarContainer) {
      setPaths({
        homePath: navbarContainer.dataset.homePath,
        channelsPath: navbarContainer.dataset.channelsPath,
        chattersPath: navbarContainer.dataset.chattersPath,
        gamesPath: navbarContainer.dataset.gamesPath,
        syncChannelPath: navbarContainer.dataset.syncChannelPath,
        syncBotPath: navbarContainer.dataset.syncBotPath,
        logoutPath: navbarContainer.dataset.logoutPath,
        currentUserNick: navbarContainer.dataset.currentUserNick,
        logoPath: navbarContainer.dataset.logoPath,
      });
    }
  }, []);

  return (
    <Navbar bg="dark" expand="lg" className="pillnav p-3 m-3">
      <div className="container-fluid px-0">
        <Navbar.Brand href={paths.homePath} className="ms-3 d-flex align-items-center">
          <img src={paths.logoPath} alt="Logo" height="40" className="d-inline-block align-top" />
          <span className="text-white mx-4">Hi {paths.currentUserNick}</span>
        </Navbar.Brand>

        {/* Custom Animated Toggler Button */}
        <button 
          className={`custom-toggler ${isOpen ? 'open' : ''}`}
          onClick={() => setIsOpen(!isOpen)}
          aria-label="Toggle navigation"
        >
          <div className="bar"></div>
          <div className="bar"></div>
          <div className="bar"></div>
        </button>

        {/* Navbar Links - Toggleable */}
        <Navbar.Collapse id="basic-navbar-nav" className={isOpen ? "show" : ""}>
          <Nav className="pillnav-container">
            {/* First 4 items */}
            <div className="top-row">
              <Nav.Link href={paths.homePath} className="pillnav-link">Home</Nav.Link>
              <Nav.Link href={paths.channelsPath} className="pillnav-link">Channels</Nav.Link>
              <Nav.Link href={paths.chattersPath} className="pillnav-link">Chatters</Nav.Link>
              <Nav.Link href={paths.gamesPath} className="pillnav-link">Games</Nav.Link>
            </div>

            {/* Divider */}
            <div className="vertical-line"></div>

            {/* Last 3 items centered properly */}
            <div className="bottom-row">
              <Button variant="primary" className="pillnav-link">Sync Channel</Button>
              <Nav.Link href={paths.syncBotPath} className="pillnav-link">Sync Bot</Nav.Link>
              <Button variant="danger" className="pillnav-link">Log Out</Button>
            </div>
          </Nav>
        </Navbar.Collapse>
      </div>
    </Navbar>
  );
};

export default PillNavbar;
